<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9 11.25C9 11.8023 8.55228 12.25 8 12.25C7.44772 12.25 7 11.8023 7 11.25C7 10.6977 7.44772 10.25 8 10.25C8.55228 10.25 9 10.6977 9 11.25ZM7.0959 5.57182C7.25723 5.23223 7.60226 5 8.00005 5C8.55233 5 9.00005 5.44772 9.00005 6C9.00005 6.16133 8.94776 6.26258 8.86775 6.3488C8.77327 6.4506 8.62619 6.54208 8.44395 6.61535C7.87042 6.84591 7.24999 7.41759 7.25005 8.25005C7.25008 8.66426 7.58589 9.00003 8.0001 9C8.41431 8.99997 8.75008 8.66416 8.75005 8.24995C8.75005 8.23733 8.75361 8.20506 8.79529 8.15385C8.83952 8.09949 8.91277 8.04355 9.00344 8.0071C9.57805 7.7761 10.5 7.20598 10.5 6C10.5 4.61929 9.38076 3.5 8.00005 3.5C7.00164 3.5 6.14142 4.0853 5.74101 4.92818C5.56328 5.30232 5.7225 5.74971 6.09664 5.92745C6.47078 6.10518 6.91817 5.94596 7.0959 5.57182Z"
    fill="currentColor"
  />
</svg>
